import styled, { css } from 'styled-components';
import React from 'react';
import ResponsiveControl from '../ResponsiveControl';

function getGroupTitle({ theme, group }) {
    if (group) {
        return css`
            margin-top: 20px;
            padding-top: 10px;
            margin-bottom: 20px;
            text-transform: uppercase;
            color: ${theme.primary.fg};
            border-top: 1px solid ${theme.borderPaleGrey};
            border-bottom: 1px solid ${theme.borderPaleGrey};

            &:first-of-type {
                border-top: 0;
            }
        `;
    }
}

const Wrapper = styled.div`
    display: flex;
    color: var(--color-title-text-500);
    ${getGroupTitle}
`;

const LabelSC = styled.label`
    color: currentColor;
    margin-bottom: 10px;
    margin-right: 10px;
    font-weight: 500;
    font-size: 14px;
`;

const Label = ({
    style,
    display,
    module,
    children,
    className,
    activeHover,
}) => {
    return (
        <Wrapper group={module?.group} className={className} style={style}>
            <LabelSC>{children}</LabelSC>
            {module && module.isResponsible && !activeHover && (
                <ResponsiveControl display={display} />
            )}
        </Wrapper>
    );
};
export default React.memo(Label);
